import { useEffect } from "react";
import { useMap } from "react-leaflet";

// Keeps Leaflet tiles in sync when the map container is resized (e.g. panel collapse).
export const MapResize = () => {
  const map = useMap();
  useEffect(() => {
    const ro = new ResizeObserver(() => map.invalidateSize({ pan: false }));
    ro.observe(map.getContainer());
    return () => ro.disconnect();
  }, [map]);
  return null;
};
